import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useGeneralStore = defineStore('general', () => {
	// Default expandido: usuarios corporativos nuevos necesitan ver labels
	// del sidebar para descubrir módulos. Usuarios pueden colapsar y la
	// preferencia se persiste via pinia-plugin-persistedstate.
	const sidebarExpanded = ref<boolean>(true)
	const sidebarOpen = ref<boolean>(false)

	return {
		sidebarExpanded,
		sidebarOpen,

		setSideBarExpanded(value: boolean) {
			sidebarExpanded.value = value
		},
		toggleSidebarExpanded() {
			this.setSideBarExpanded(!sidebarExpanded.value)
		},

		setSidebarOpen(value: boolean) {
			sidebarOpen.value = value
		},
		toggleSidebarOpen() {
			this.setSidebarOpen(!sidebarOpen.value)
		},

		reset() {
			sidebarExpanded.value = false
			sidebarOpen.value = false
		},
	}
})
